export default __webpack_public_path__ + "static/media/Ellipse701.40250341.svg";